export enum EditSuborganizationsRoleAssignmentFlow {
  Add,
  Preview,
}
